export const REQUIRED_BASIC_DATA_FIELDS = [
  'makeSelect',
  'modelSelect',
  'vehicleType',
  'vatQualifying',
  'derivative',
  'mileage',
  'year',
  'dateOfFirstRegistration',
  'colour',
  'carType',
  'fuel',
  'doors',
  'vin',
  'transmission',
  'previousKeepersInTotal',
  'v5cLogBook',
  'ulezCompliant',
];

const isFieldFilled = (value) => {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string') return value.trim().length > 0;
  if (typeof value === 'object') {
    const inner = value.value;
    return inner !== null && inner !== undefined && inner !== '';
  }
  return true;
};

export const areRequiredBasicDataFieldsFilled = (basicData) => {
  if (!basicData) return false;
  const fields = [...REQUIRED_BASIC_DATA_FIELDS];
  if (basicData.fuel?.value !== 'Electric') {
    fields.push('engineSize');
  }
  return fields.every((field) => isFieldFilled(basicData[field]));
};
